import { Button } from '@/components/ui/button';

import type { ButtonProps } from '@/components/ui/button';

interface ExtendedButtonProps extends ButtonProps {
  label: string;
}

export function PrimaryButton({ label, variant = 'default', onClick, className, ...props }: ExtendedButtonProps) {
  return (
    <Button onClick={onClick} className={`bg-[#290BD9] hover:bg-[#2309C5] ${className}`} variant={variant} {...props}>
      {label}
    </Button>
  );
}
